<template>
  <div class="how-to-use">
    <div class="card">
      <div class="card-header">
        簡単な説明
      </div>
      <div class="card-body">
        <pre>
          オンラインで「全知全能」を行うサイトです。
          一人一端末で行います。
          進行役として一名GMを行っていただきますが、進行をするというだけなので他の方と一緒にゲームに参加できます。
          GMはルームを作成した方が行うようになっています。
          GMをする方は下の[ゲームの進行]の[GMをする方]と[PLをする方]の両方を読んでください。
          それ以外の方は下の[ゲームの進行]の[PLをする方]を読んでください。
        </pre>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        ゲームの進行
      </div>
      <div class="card-body">
        <div class="gm">
          <h2>GMをする方</h2>
          <ol>
            <li>[ルームを作成]をクリック。</li>
            <li>[ルーム名]と[パスワード]を決めて入力後、[作成]をクリック。</li>
            <li>参加者が全員集まったら[GM: ゲーム開始]をクリック。</li>
            <li>全員がお題を決定したら[GM: お題を選出]をクリック。</li>
            <li>議論が終わったら[GM: 投票に移る]をクリック。</li>
            <li>全員の投票が終わったら[GM: 結果を表示]をクリック。</li>
            <li>[GM: 終了]をクリック。</li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="gm">
          <h2>PLをする方</h2>
          <ol>
            <li>[ルーム一覧]から参加したいルームをクリック。</li>
            <li>[パスワード]を入力後、[参加]をクリック。</li>
            <li>ゲームが始まったら入力欄にお題を入力して[決定]をクリック。</li>
            <li>お題が表示されたらチャット欄で議論をしてください。チャット欄の下にある入力欄に入力することでコメントできます。</li>
            <li>投票画面になったらお題主だと思うプレイヤーを選び[投票]をクリック。</li>
          </ol>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: 'how-to-use',
  components: {

  },
  data() {
    return {

    }
  }
}
</script>
<style scoped>
</style>
